import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Gtp } from '../../../../shared/gtp';

@Component({
  selector: 'app-contactos',
  templateUrl: './contactos.component.html',
  styleUrls: ['./contactos.component.scss']
})
export class ContactosComponent implements OnInit {

  constructor(
    private router: Router,
    public gtp: Gtp,
  ) { }

  ngOnInit(): void {
  }

  closeMovil(){
    this.gtp.setAdminSidebar(true);
  }

  contactarWhatsApp(telefono: string): void {
    const mensaje = 'Hola, estoy interesado en obtener más información sobre GTP. ¿Pueden ayudarme?';
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  }
}
